import RequestService from './request-service';

export default class GetLiveMatchTabs  extends RequestService {
  constructor() {
    super();
    this.endpoint = this.$config.endpoints.getLiveMatchTabs;
    this.method = 'get';
    this.addGetParam('Culture', this.$config.defaultHeaders.Culture);
    this.headers = null;
  }
}
